import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../utils/api";

import { useTranslation } from "react-i18next";

const VerifyOTP = () => {
  const { i18n } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (code.length !== 6) return;

    setLoading(true);
    try {
      await api.post("/auth/verify-otp", {
        identifier: state?.email,
        code,
        type: "email_verification",
      });

      Swal.fire("Verified!", "Your email has been confirmed.", "success");
      navigate(`/${i18n.language}/login`);
    } catch (error) {
      Swal.fire("Invalid Code", "Please check and try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      await api.post("/auth/resend-otp", {
        identifier: state?.email,
        type: "email_verification",
      });
      Swal.fire("Sent!", "A new code has been sent.", "success");
    } catch {
      Swal.fire("Error", "Failed to resend code.", "error");
    }
  };

  if (!state?.email) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-600">
          Error: No email found. Please register again.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full text-center">
        <h2 className="text-2xl font-bold mb-2">Verify Your Email</h2>
        <p className="text-gray-600 mb-6">
          We sent a 6-digit code to <strong>{state.email}</strong>
        </p>

        <input
          type="text"
          maxLength="6"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          className="w-full text-center text-2xl font-mono tracking-widest border rounded-lg py-3 mb-4"
          placeholder="000000"
        />

        <button
          onClick={handleVerify}
          disabled={loading || code.length !== 6}
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? "Verifying..." : "Verify"}
        </button>

        <button
          onClick={handleResend}
          className="mt-4 text-blue-600 hover:underline text-sm"
        >
          Resend Code
        </button>
      </div>
    </div>
  );
};

export default VerifyOTP;
